var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 941,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620 0h-60v100h61l19-19V20L620 0Zm0 67-12 13h-28V20h27l13 14v33Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M830.14 100H760V9.86L769.86 0h60.28L840 9.86V40h-20V20h-40v60h40V60h20v30.14l-9.86 9.86Zm109.89 0h-80V70h20v10h40V67.21L859.84 47.2l.25-47.2h79.94v30h-20V20h-40.05l-.06 12.8 60.11 19.99V100Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M520 0h-20v20h20V0Zm0 80h-20v20h20V80Zm0-40h-20v20h20V40Z",
    opacity: 0.5,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M270 20V0h-70v100h70V80h-50V60h30V40h-30V20h50Zm90 0V0h-70v100h70V80h-50V60h30V40h-30V20h50Zm-180 80-24.83-31L170 54.14V15.86L154.14 0H100v100h20V70h7.5l22.5 30h30Zm-60-80h25.86l4.14 4.14v21.72L145.86 50H120V20Zm340 80h-26.18L400 32.36V100h-20V0h26.18L440 67.64V0h20v100ZM80 30V9.86L70.14 0H9.86L0 9.86V100h70.14L80 90.14V50H60L50 60v10h10v10H20V20h40v10h20Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m671 0-10 10v90h70l10-10V0h-70Zm50 76-4 4h-36V24l4-4h36v56Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7fc35195491cf63473e154ae12c8c680.svg";
export { ForwardRef as ReactComponent };